module.exports = __webpack_public_path__ + "img/multipleAdd2x.png?9126bf026a4e2b19c06df037a8900b6e";